import * as ActionTypes from '../ActionTypes';

export const GetContractorAction = () => {
    return {
        type: ActionTypes.CONTRACTOR_GET_REQUEST,
    }
}

export const AddContractorAction = (params, callback) => {
    return {
        type: ActionTypes.CONTRACTOR_ADD_REQUEST,
        params,
        callback
    }
}

export const UpdateContractorAction = (params, callback) => {
    return {
        type: ActionTypes.CONTRACTOR_UPDATE_REQUEST,
        params,
        callback
    }
}

export const DeleteContractorAction = (params, callback) => {
    return {
        type: ActionTypes.CONTRACTOR_DELETE_REQUEST,
        params,
        callback
    }
}